import React, { FC } from 'react';

import Mersenne from '../../../../images/clientLogos/prime2.png';
import AdepaLogo from '../../../../images/clientLogos/adepa.png';
import Coutts from '../../../../images/clientLogos/coutts.png';
import CorumButler from '../../../../images/clientLogos/corumbutler.png';
import Ucilux from '../../../../images/clientLogos/ucilux.png';
import Ascender from '../../../../images/clientLogos/ascender.png'; // Gemini are now Ascender
import wCapital from '../../../../images/clientLogos/amadeus.png'; // WCapital are now Amadeus
import quayside from '../../../../images/clientLogos/quayside.png';
import Trium from '../../../../images/clientLogos/trium.png';
import Gem from '../../../../images/clientLogos/gem.png';
import Nikko from '../../../../images/clientLogos/smbc_nikko.jpeg';
import Bflexion from '../../../../images/clientLogos/bflexion.png';
import Pure from '../../../../images/clientLogos/pure_capital.png';
import GreshamHouse from '../../../../images/clientLogos/gresham_house.png';
import BuyAndHold from '../../../../images/clientLogos/buy_and_hold.png';
import EPIC from '../../../../images/clientLogos/epic.png';
import Zeus from '../../../../images/clientLogos/zeus.png';
import EBI from '../../../../images/clientLogos/ebi.png';
import HVB from '../../../../images/clientLogos/hvb.png';
import ZBInvest from '../../../../images/clientLogos/zbinvest.png';
import Unicredit from '../../../../images/clientLogos/unicredit.png';
import SuraLogo from '../../../../images/clientLogos/sura.png';
import GeneraliLogo from '../../../../images/clientLogos/generali.png';

// ?raw required: vite-plugin-svgr turns .svg into a React component; jsPDF addSvgAsImage needs the SVG markup string
import EPIC_SVG from '../../../../images/clientLogos/epic.svg?raw';

interface LogoRenderProps {
  clientName: string | null;
  configName: string | null;
}

// SVG markup for PDF export (FileExportButton → addSvgAsImage). UI logos stay as PNG via handleLogo.
export const clientSvgLogos: Record<string, string> = {
  epic: EPIC_SVG,
};

export function handleLogo(
  clientName: string | null,
  configName: string | null,
) {
  // Handle for sub-accounts on adepa with different logos (eventually this should be handled on the backend)
  if (clientName === 'adepa') {
    switch (configName) {
      case 'buyandhold_funds':
        return BuyAndHold;
      case 'sura_funds':
        return SuraLogo;
      default:
        return AdepaLogo;
    }
  }

  switch (clientName) {
    case 'ucilux':
      return Ucilux;
    case 'mersenne':
      return Mersenne;
    case 'quayside':
      return quayside;
    case 'gemini':
      return Ascender;
    case 'wcapital':
      return wCapital;
    case 'coutts':
      return Coutts;
    case 'gem':
      return Gem;
    case 'butler':
      return CorumButler;
    case 'trium':
      return Trium;
    case 'bflexion':
      return Bflexion;
    case 'snif':
      return Nikko;
    case 'pure':
      return Pure;
    case 'greshamhouse':
      return GreshamHouse;
    case 'epic':
      return EPIC;
    case 'zeus':
      return Zeus;
    case 'ebi':
      return EBI;
    case 'hvb':
      return HVB;
    case 'zbinvest':
      return ZBInvest;
    case 'unicredit':
      return Unicredit;
    case 'generali':
      return GeneraliLogo;
    default:
      return Mersenne;
  }
}

const LogoRender: FC<LogoRenderProps> = ({ clientName, configName }) => {
  const Logo = handleLogo(clientName, configName);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center', // Vertically centers the image
        height: '2.03em',
      }}
    >
      {typeof Logo === 'string' ? (
        <img
          alt={`${clientName} logo`}
          style={{
            right: 0, // Pushes the image to the right edge
            height: '100%',
            maxWidth: '7.50rem',
            objectFit: 'contain',
          }}
          src={Logo}
        />
      ) : typeof Logo === 'function' ? (
        // This handels for SVG logos, in the case of a string we just render the image
        React.createElement(Logo, {
          style: {
            right: 0,
            height: '100%',
            maxWidth: '7.50rem',
            objectFit: 'contain',
            display: 'block',
          },
          'aria-label': `${clientName} logo`,
        })
      ) : null}
    </div>
  );
};

export default LogoRender;
